﻿export class CancelRequested {
    static eventName() { return 'CancelRequested'; }

    eventName = CancelRequested.eventName;
}